<template>
    <div class="mb-4">
        <h5>{{ $t('Company Information') }}</h5>
        <div class="px-0 mb-3 mt-4">

            <b-row class="mb-3">
                <b-col cols="12" md="6">
                    <label>{{ $t('Company Name') }} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="params.name" @keydown="onChange('name')" :placeholder="$t('Fill name')"/>
                    <div v-if="error['name']" class="invalid-feedback d-block mb-3">
                        {{$t(error['name'])}}
                    </div>
                </b-col>
                <b-col cols="12" md="6">
                    <label>{{ $t('Company Name (English)') }} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="params.enName" @keydown="onChange('enName')" :placeholder="$t('Fill name')"/>
                    <div v-if="error['enName']" class="invalid-feedback d-block mb-3">
                        {{$t(error['enName'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col sm="12" md="6">
                    <label>{{ $t('Business Registration Number') }} <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="params.orgRegisterNo" @keydown="onChange('orgRegisterNo')" :placeholder="$t('Fill number')"/>
                    <div v-if="error['orgRegisterNo']" class="invalid-feedback d-block mb-3">
                        {{$t(error['orgRegisterNo'])}}
                    </div>
                </b-col>

                <b-col cols="12" md="6">
                    <div class="label-group">
                        <label>{{ $t('Business Registration Certificate') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup('showPopup')">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                            <NewPopupInfo :name="'business_certificate'" v-if="showPopup"></NewPopupInfo>
                        </span>
                    </div>
                    <FileUploader  
                        :type="'browse'"
                        :ref="'orgRegister'"
                        :allowed_types = "['jpg','jpeg', 'png','pdf']"
                        :size="10*1024*1024"
                        :default_image="params.orgRegister"
                        @capture-file="captureFile($event,'orgRegister')" 
                        @remove-image="removeImage($event,'orgRegister')">
                    </FileUploader>
                    <div v-if="error['orgRegister']" class="invalid-feedback d-block mb-3">
                        {{$t(error['orgRegister'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col cols="12" md="6">
                    <label>{{ $t('Date of Establishment') }} <span class="text-danger">*</span></label>
                    <date-picker v-model="params.registerDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('registerDate')"></date-picker>
                    <div v-if="error['registerDate']" class="invalid-feedback d-block mb-3">
                        {{$t(error['registerDate'])}}
                    </div>
                </b-col>

                <b-col cols="12" md="6">
                    <label>{{ $t('Registered capital') }} <span class="text-danger">*</span></label>
                    <MaskAmount @set-price="changePrice($event)" :bus="registerAmt" ref="registerAmt"></MaskAmount>
                    <div v-if="error['registerAmt']" class="invalid-feedback d-block mb-3">
                        {{$t(error['registerAmt'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-5">
                <b-col cols="12" md="6">
                    <div class="label-group">
                        <label>{{ $t('Other Supporting Document') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup('showPopup_2')">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                            <NewPopupInfo :name="'other_accessories'" v-if="showPopup_2"></NewPopupInfo>
                        </span>
                    </div>
                    <FileUploader  
                        :type="'browse'"
                        :ref="'otherAccessories'"
                        :allowed_types = "['jpg','jpeg', 'png','rar','zip']"
                        :size="20*1024*1024"
                        :default_image="params.otherAccessories"
                        @capture-file="captureFile($event,'otherAccessories')" 
                        @remove-image="removeImage($event,'otherAccessories')">
                    </FileUploader>
                    <div v-if="error['otherAccessories']" class="invalid-feedback d-block mb-3">
                        {{$t(error['otherAccessories'])}}
                    </div>
                </b-col>
            </b-row>

           
        </div>
        
    </div>
</template>

<script>
import Vue from "vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';
import MaskAmount from "@/components/Mask/MaskAmount";

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        maxSize:4,
        showPopup:false,
        showPopup_2:false,
        lang_date:'en',
        success:null,
        userNo:null,
        accountId:null,
        registerAmt:new Vue(),
        file:{
            orgRegister:'',
            otherAccessories:''
        },
        params:{
            name:'',
            enName:'',
            orgRegister:'',
            orgRegisterNo:'',
            registerDate:'',
            registerAmt:'',
            otherAccessories:''
        },
        error:{
            name:'',
            enName:'',
            orgRegister:'',
            orgRegisterNo:'',
            registerDate:'',
            registerAmt:'',
            otherAccessories:''
        },
        optional:[]
    }
  },
  components:{
    NewDocOption,
    FileUploader,
    Select2,
    NewPopupInfo,
    DatePicker,
    MaskAmount
  },
  props:['provinceOpt','information','user_no','account_id'],
  methods:{
    changePrice(event){
        this.error.registerAmt = '';
        this.params.registerAmt = event;
    },
    getFile(index,file_id){
        let self = this;
        CreateAccount.getFile({fileId:file_id}).then(response => {
            let data_file = response.data.data[0];
            if(data_file.type == 8){
                self.params.orgRegister = data_file.file;
                self.$refs['orgRegister'].image =data_file.file;
            }
            else if(data_file.type == 12){
                self.params.otherAccessories = data_file.file;
                self.$refs['otherAccessories'].image =data_file.file;
            }
        });
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(!self.params[key] && !self.optional.includes(key)){
                console.log(key);
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    uploadFile(account_id,user_no){
        let self = this;
        this.success = null;
        this.accountId = account_id;
        this.userNo = user_no;

        this.error.orgRegister='';
        this.error.otherAccessories='';

        let file = [];
        if(self.params.orgRegister.indexOf("base64")!=-1){
            file.push({
                "type":8,
                "maxSize":10*1024*1024,
                "file":self.params.orgRegister
            });
        }
        if(self.params.otherAccessories.indexOf("base64")!=-1){
            file.push({
                "type":12,
                "maxSize":10*1024*1024,
                "file":self.params.otherAccessories
            });
        }
        
        if(file.length>0){
            CreateAccount.uploadFile({
                "accountId":self.accountId,
                "userNo":""+self.userNo,
                "fileUpload":file
            }).then(response => {
                const data = response.data.data;
                let fileList = data["file"];
                for(let i=0;i<fileList.length;i++){
                    if(fileList[i].type==8){
                        self.file.orgRegister = fileList[i].fileId;
                    }
                    else{
                        self.file.otherAccessories = fileList[i].fileId;
                    }
                }
                self.success = true;
                self.$emit('file-uploaded');
            }).catch(err => {
                self.checkError(err);
            });
        }
        else{
            self.success = true;
            self.$emit('file-uploaded');
        }
    },
    checkError(err){
        try{
            let self = this;
            const response = err.response;  
            if(response.status == 400 || response.status == 500){
                if(typeof response.data.message === 'string'){
                    self.$swal({
                        icon: 'info',
                        html:response.data.message,
                        showConfirmButton: true,
                        confirmButtonText: self.$t('OK')
                    });
                    self.$emit('on-error');
                }
                else{
                    if(response.data.message['file']){
                        let fileList = response.data.message['file'];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==8){
                                self.error.orgRegister=fileList[i].message;
                            }
                            else if(fileList[i].type==12){
                                self.error.otherAccessories=fileList[i].message;
                            }
                        }
                    }
                    self.success = false;
                    self.$emit('on-error');
                }
            }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                        path: '/login', 
                    });
            }
            else{
                if(localStorage.getItem("token")){
                    var msg = (response.data)?response.data.message:err.message;
                    this.$notify({
                        type: 'warn',
                        text: msg
                    })
                }
            }
        }catch(e){
            console.log(err);
        }
    },
    onChange(name){
        this.error[name]="";
    },
    togglePopup(name){
        this[name]=!this[name];
    },
    selectedDocumentBeneficiary(data){
        this.doc_type = data.index;
    },
    captureFile($event,name) {
        this.error[name]="";
        this.params[name]=$event;
    },
    removeImage($event,key){
        console.log($event);
        this.params[key]="";
        this.error[key] = "";
    },
    doEscapeMarkup(markup){
        return markup;
    }
  },
  mounted(){
    let self = this;
    this.$nextTick(() => {

        if(this.information){    
            Object.keys(this.params).forEach(function(key) {
                if(typeof self.file[key]!=="undefined"){
                    self.file[key]=self.information[key];
                    self.getFile(key,self.information[key]);
                }
                else if(typeof self.params[key] !== 'undefined'){
                    self.params[key]=self.information[key];
                }
            });
            if(self.params.registerAmt){
                this.$refs['registerAmt'].init(self.params.registerAmt);
            }
        }

        if(this.user_no){
            this.userNo = this.user_no;
            this.accountId = this.account_id;
        }
    });
  }
}
</script>